import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addItemToCartList,
  fetchCartProducts,
} from "./actions";

interface CartProductList {
  isLoading: boolean;
  isError: boolean;
  listName: string;
  listId: string;
  cartProducts: {
    products: Product[];
  };
  usersShoppingList: [];
}

interface Product {
  id?: number;
  name?: string;
  quantity?: number;
  item_id?: string;
  type?: string;
  category_id?: number

}

const initialState: CartProductList = {
  isLoading: false,
  isError: false,
  listName: "",
  cartProducts: {
    products: [],
  },
  listId: "",
  usersShoppingList: [],
};

const fallbackErrorMessage = "Something went wrong. Please try again."

export const cartProductSlice = createSlice({
  name: "cartProductSlice",
  initialState,
  reducers: {
    resetCartProductList: () => initialState,
    setCartItemListData: (state, action) => {
      if (!Array.isArray(state.cartProducts)) {
        state.cartProducts.products = [
          ...state.cartProducts.products,
        ];

      }
      if (action.payload) {
        if (action.payload?.listType == "Product" || action.payload?.type == "Product") {
          const existingIndex = state.cartProducts.products.findIndex(
            (item: any) => item.item_id == action.payload.item_id
          );
          if (existingIndex !== -1) {
            if (action.payload?.quantity == 0) {
              state.cartProducts.products = state.cartProducts.products.filter(
                (item: any) => item.item_id != action.payload.item_id
              );

              return;
            }
            state.cartProducts.products[existingIndex] = {
              ...state.cartProducts.products[existingIndex],
              ...action.payload,
            };

          } else {
            state.cartProducts.products.push(action.payload);
          }

        }
      }
    },
    updateCartShoppingList: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.listName = action.payload?.name;
      state.listId = action.payload.categoryId;
      if (!Array.isArray(state.cartProducts)) {
        state.cartProducts.products = [
          ...state.cartProducts.products,
        ];
      }
    
      if (action.payload) {
          state.cartProducts.products = state.cartProducts.products.map((item: any) => {
            if (item.item_id == action?.payload?.itemId ) {
                return {
                  ...item,
                  quantity: action?.payload?.quantity,
                };
              
            } 
            return item;
          });
           if(action?.payload?.deletedId || action?.payload?.quantity == 0)
            {
              state.cartProducts.products =state.cartProducts.products.filter(
                    (item:any) => item.id != action.payload?.deletedId
                  );
            return
            }

          const existingProduct = state.cartProducts.products.find((item: Product) => item?.item_id == action.payload?.itemId);
            // If the product doesn't exist, add it to the array
          if (!existingProduct) {
            state.cartProducts.products.push({
              id: action.payload.insertId,
              category_id:  action.payload.categoryId,
              quantity: action.payload.quantity,
              item_id: action.payload.itemId,
              type: action.payload.listType,
            });
          }
        }
    


    },

    setActiveCartList: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.listName = action.payload?.name
      state.listId = action.payload?.id
      state.cartProducts.products = action.payload?.items ?? [];
    },

    subtituteProductFromCartList: (state, action) => {
      const substitutions = action?.payload;
    
      if (Array.isArray(substitutions)) {
        substitutions.forEach(({ currentProductID, substituteProductID }) => {
          const existingIndex = state?.cartProducts?.products?.findIndex(
            (item: any) => item?.item_id === currentProductID
          );
    
          if (existingIndex !== -1) {
            state.cartProducts.products[existingIndex].item_id = substituteProductID;
          }
        });
      }
    },
    
    updateCartListByStore: (state, action)  => {
      state.cartProducts.products = action.payload ?? [];
    }

  },
  extraReducers: (builder) => {

    // Add item
    builder.addCase(addItemToCartList.pending, (state: any) => {
      // state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      addItemToCartList.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        if (!Array.isArray(state.cartProducts)) {
          state.cartProducts.products = [
            ...state.cartProducts.products,
          ];

        }
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated = true
        if (action.payload) {
          if (action?.payload?.resultData) {
            state.cartProducts.products = state.cartProducts.products.map((item: any) => {
              if (item.id == action?.payload?.resultData?.id) {
                return {
                  ...item,
                  quantity: action?.payload?.resultData?.quantity,
                };
              }
              return item;
            });
          }

          else if (action?.payload?.deletedId) {
            state.cartProducts.products = state.cartProducts.products.filter(
              (item: any) => item.id != action.payload?.deletedId
            );
            return
          }
          else {
            state.cartProducts.products = [
              ...state.cartProducts.products,
              action?.payload?.resultData,
            ];
          }



        }
      }
    );
    builder.addCase(addItemToCartList.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;

    });

    // Get list items
    builder.addCase(fetchCartProducts.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchCartProducts.fulfilled, (state: any, action) => {
      state.isLoading = false;
      state.isError = false;
      if (action.payload?.getListData) {

        state.cartProducts.products = [
          ...(action.payload?.getListData[0]?.items ?? []).filter(
            (val: { type: string }) => val.type == "Product"
          ),
        ];
        state.listName = action.payload?.getListData?.[0]?.name;
        state.listId = action.payload?.getListData?.[0]?.id;


      }
    });
    builder.addCase(fetchCartProducts.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

  },
});

export const {
  resetCartProductList,
  setCartItemListData,
  updateCartShoppingList,
  setActiveCartList,
  subtituteProductFromCartList,
  updateCartListByStore
} = cartProductSlice.actions;
export const cartProductSliceReducer = cartProductSlice.reducer;